/**
 * List of commands for the B24 parent window
 */
export enum MessageCommands {
  getInitData = 'getInitData',
  setInstallFinish = 'setInstallFinish',
  setInstall = 'setInstall',
  refreshAuth = 'refreshAuth',
  setAppOption = 'setAppOption',
  setUserOption = 'setUserOption',
  resizeWindow = 'resizeWindow',
  reloadWindow = 'reloadWindow',
  setTitle = 'setTitle',
  setScroll = 'setScroll',
  openApplication = 'openApplication',
  closeApplication = 'closeApplication',
  openPath = 'openPath',
  imCallTo = 'imCallTo',
  imPhoneTo = 'imPhoneTo',
  imOpenMessenger = 'imOpenMessenger',
  imOpenHistory = 'imOpenHistory',
  selectUser = 'selectUser',
  selectAccess = 'selectAccess',
  selectCRM = 'selectCRM',
  /**
   * @memo this not work. Need test
   */
  showAppForm = 'showAppForm',
  getInterface = 'getInterface',
  placementBindEvent = 'placementBindEvent'
}
